import React from "react";
import { useNavigate } from "react-router-dom";
import logo1 from "../../images/logo1.PNG"; 
import UserName from "../User/UserName"; 
import "../../styles/NavbarLoggedIn.css";

export default function NavbarLoggedIn() {
  const navigate = useNavigate();

  // Función para redirigir al login o página principal al hacer logout
  const handleLogout = () => {
    // Aquí tu lógica de logout si la tuvieras
    navigate("/");
  };

  return (
    <header className="navbar-loggedin">
      <div className="navbar-loggedin-content">
        {/* Logo y Título */}
        <div className="navbar-loggedin-logo">
          <img src={logo1} alt="Logo" className="navbar-loggedin-logo-img" />
          <span className="navbar-loggedin-title">Mercanteomexico</span>
        </div>

        {/* Nombre del usuario */}
        <div className="navbar-loggedin-user">
          <UserName />
        </div>
      </div>
    </header>
  );
}
